import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FileCard } from "../../../../../../core/types/file-card.types";
import { defaultFileCard, defaultImgSize } from "../../configs/file-card-config";
import { ButtonAction } from "../../../../../../core/types/button-action.types";
import { ImgSize } from "../../types/file-card.types";
import { FileCardImageComponent } from "../file-card-image/file-card-image.component";
import { FormatSizePipe } from "../../../../../pipes/format-size.pipe";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { MatMiniFabButton } from "@angular/material/button";
import { FileProgressBarStatusComponent } from "../../../file-progress-bar-status/file-progress-bar-status.component";

@Component({
  selector: 'div[app-card-variant-second]',
  standalone: true,
  imports: [
    FileCardImageComponent,
    FormatSizePipe,
    MatTooltip,
    MatIcon,
    MatMiniFabButton,
    FileProgressBarStatusComponent
  ],
  templateUrl: './card-variant-second.component.html',
  styleUrl: './card-variant-second.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardVariantSecondComponent {
  fileCard = input<FileCard>(defaultFileCard);
  imgSize = input<ImgSize>(defaultImgSize);
  isNeedPreview = input<boolean>(false);
  infoTooltip = input<string>('');
  isAction = input<boolean>(false);
  isImage = input<boolean>(false);
  handleBtnClick = output<ButtonAction>();

  public getActionButtonsClass(): string {
    return this.fileCard().isEditModeActive ? 'three-icon' : 'no-edit';
  }

  public handleClick(buttonAction: ButtonAction): void {
    this.handleBtnClick.emit(buttonAction);
  }
}
